import { render, staticRenderFns } from "./HomeCardNews.vue?vue&type=template&id=3ef4ca8c&scoped=true&"
import script from "./HomeCardNews.vue?vue&type=script&lang=js&"
export * from "./HomeCardNews.vue?vue&type=script&lang=js&"
import style0 from "./HomeCardNews.vue?vue&type=style&index=0&id=3ef4ca8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef4ca8c",
  null
  
)

export default component.exports